import React from "react";
import { Outlet } from "react-router-dom";

export default function OmniCineEditorShell(): JSX.Element {
  return <Outlet />;
}